<template>
    <figure class="image is-1by1" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
        <div onclick="window.open('https://fb.me/kmsodeutschland/', '_blank')" class="pointer-hand">
            <img src="/img/social/facebook.png" alt="Facebook" :class="{ 'blog-social-icons-mobile': this.isMobile }">
        </div>
    </figure>
</template>

<script>
    export default {
        name: 'Blog-1',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
